import ScootersLockHistoryTable from './ScootersLockHistoryTable';
export default ScootersLockHistoryTable;
